import { render } from "./EditPodani.vue?vue&type=template&id=8bc1f52e"
import script from "./EditPodani.vue?vue&type=script&lang=js"
export * from "./EditPodani.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\Arion\\SATRA\\SATRA_Inzenyring\\inzenyring\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__